import { createSelector } from 'reselect'
import getMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/get-max-free-samples-count'

const getHasReachedMaxFreeSamplesCountMessageCartSelect = createSelector(
  getMaxFreeSamplesCountCartSelect,
  (maxSamplesCount) => {
    return `You can’t add more than ${maxSamplesCount} free samples`
  }
)

export default getHasReachedMaxFreeSamplesCountMessageCartSelect
